export default __webpack_public_path__ + "static/media/events3.34f0fefd.png";